import { PAGE_TRANSITION_TUNING } from "./page-transition"

interface TransitionConfig {
  duration: string
  easing: string
}

const IOS_NAV_TWEEN: TransitionConfig = {
  duration: PAGE_TRANSITION_TUNING.duration,
  easing: PAGE_TRANSITION_TUNING.easing,
}

const IOS_NAV_TWEEN_FAST: TransitionConfig = {
  duration: PAGE_TRANSITION_TUNING.popDuration,
  easing: PAGE_TRANSITION_TUNING.easing,
}

const IOS_NAV_REDUCED: TransitionConfig = {
  duration: "0.01s",
  easing: "linear",
}

export const ANIMATION_CONFIG_V12 = {
  tween: IOS_NAV_TWEEN,
  fast: IOS_NAV_TWEEN_FAST,
  reducedMotion: IOS_NAV_REDUCED,
} as const

let _cachedConfig: TransitionConfig | null = null
let _cachedIsLowEnd: boolean | null = null

function detectLowEndDevice(): boolean {
  if (_cachedIsLowEnd !== null) return _cachedIsLowEnd
  if (typeof navigator === "undefined") {
    _cachedIsLowEnd = false
    return false
  }
  _cachedIsLowEnd =
    (navigator.hardwareConcurrency != null &&
      navigator.hardwareConcurrency <= 2) ||
    // @ts-expect-error -- non-standard but available on Chrome Android
    (navigator.deviceMemory != null && navigator.deviceMemory <= 2)
  return _cachedIsLowEnd
}

function detectReducedMotion(): boolean {
  return (
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  )
}

export function getOptimizedConfigV12(): TransitionConfig {
  if (_cachedConfig) return _cachedConfig

  if (detectReducedMotion()) {
    _cachedConfig = ANIMATION_CONFIG_V12.reducedMotion
  } else if (detectLowEndDevice()) {
    _cachedConfig = ANIMATION_CONFIG_V12.fast
  } else {
    _cachedConfig = ANIMATION_CONFIG_V12.tween
  }

  return _cachedConfig
}

export const HARDWARE_ACCELERATION_STYLES_V12: React.CSSProperties = {
  backfaceVisibility: "hidden",
  WebkitBackfaceVisibility: "hidden",
  willChange: "transform, opacity",
}
